<template>
  <article
    class="
      grid grid-cols-card
      gap-x-6
      rounded
      bg-grey-400
      px-5
      pt-5
      pb-3
      cursor-pointer
      hover:shadow-sm
    "
    @click="openModal(bookData.id)"
  >
    <img
      :src="bookData.imageURl"
      :alt="bookData.name"
      class="shadow-md mb-3 h-auto"
      width="134"
    />
    <div class="mb-3">
      <h3 class="text-base text-black-900 font-medium mb-2">
        {{ bookData.name }}
      </h3>
      <h4 class="text-grey-700 text-sm uppercase font-medium mb-3">
        {{ bookData.author }}
      </h4>
      <p class="text-sm text-black-600">
        Secondary Three is turning out to be a great year for Abriana and
        Octavia. Abri’s standing at BTSGS receives a boost after she wins a
        major writing competition, and Octavia’s a rising star in the school’s
        tennis team. But when the BFFs encounter a strange waterspout—part of a
        barrage of severe.
      </p>
    </div>
    <div class="mb-7">
      <h5 class="text-grey-700 text-sm">Imprint:</h5>
      <p class="text-black-600 text-sm">{{ bookData.imprint }}</p>
    </div>
    <div class="flex mb-7">
      <div class="flex-1">
        <h5 class="text-grey-700 text-sm">ISBN:</h5>
        <p class="text-black-600 text-sm">{{ bookData.isbn }}</p>
      </div>
      <div>
        <h5 class="text-grey-700 text-sm">Pub. Date:</h5>
        <p class="text-black-600 text-sm">{{ bookData.pubDate }}</p>
      </div>
    </div>
    <div class="flex items-center space-x-5">
      <export-pdf-button @export-to-pdf="exportToPdf" />
      <button-bookmark
        :added-to-bookmark="addedToBookmark"
        @bookmark-click="handleBookmark"
      />
    </div>

    <div class="flex items-center justify-between">
      <span
        class="
          before:empty-content
          before:w-1.5
          before:h-1.5
          before:rounded-full
          before:mr-1.5
          text-base
          flex
          items-center
        "
        :class="[
          bookData.isAvailable
            ? 'before:bg-green-700 text-green-700'
            : 'before:bg-red-600 text-red-600',
        ]"
      >
        {{ isAvailableWord }}
      </span>

      <span class="text-black-900 text-xl font-medium uppercase">
        SGD 12.00
      </span>
    </div>
  </article>
</template>

<script>
import ExportPdfButton from "@/components/buttons/ButtonExportPdf.vue";
import ButtonBookmark from "@/components/buttons/ButtonBookmark.vue";

export default {
  name: "CardBook",
  components: {
    ExportPdfButton,
    ButtonBookmark,
  },
  props: {
    bookData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // temp
      addedToBookmark: false,
    };
  },
  methods: {
    handleBookmark() {
      this.addedToBookmark = !this.addedToBookmark;
      this.$modal.show("shortlist-modal", "add-shortlist-modal");
    },
    openModal(bookId) {
      this.$emit("open-modal", bookId);
    },
    exportToPdf() {
      this.$emit("export-to-pdf", this.bookData);
    },
  },
  computed: {
    isAvailableWord() {
      return this.bookData.isAvailable ? "Available" : "Not available";
    },
  },
};
</script>
